export const AppSettings = {
  sessionTimeoutInMs: 30 * 60 * 1000,  // 30 minutes
  warningBeforeInMs: 2 * 60 * 1000     // 2 minutes before timeout
};